
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from "@/components/ui/use-toast";

interface AuthComponentProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const AuthComponent = ({ open, onOpenChange }: AuthComponentProps) => {
  const { toast } = useToast();
  
  const handleLogin = async () => {
    const { data, error } = await supabase.auth.signInWithPassword({
      email: 'admin@ein-grosses-leben.de',
      password: 'Admin123!@#'
    });
    
    if (error) {
      console.error('Login error:', error);
      toast({
        title: "Fehler beim Anmelden",
        description: error.message,
        variant: "destructive",
      });
    } else {
      onOpenChange(false); // Schließe den Dialog nach erfolgreicher Anmeldung
    }
  };

  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle className="text-center">Admin-Bereich</DialogTitle>
      </DialogHeader>
      <div className="flex justify-center p-4">
        <Button onClick={handleLogin} className="w-full">
          Als Admin anmelden
        </Button>
      </div>
    </DialogContent>
  );
};
